import React from 'react';

export const useId = () => {
    const id = React.useId().replaceAll(':', '-');
    return id;
};
